@if (isElevateTeam) {
  @if (params.data.status !== 'Completed') {
    <a href="{{ params.data.inviteLink }}" class="invite-link" (click)="showInviteLinkModal($event, inviteLinkModal)">Invite Link</a>
  }
} @else {
  {{ params.data.accessCode }}
}

<ng-template #inviteLinkModal let-modal>
  <div class="modal-header">
    <div class="modal-title">Copy individual member link</div>
    <img class="close-modal-image" src="/assets/images/close-static.svg" (click)="modal.dismiss()" />
  </div>
  <div class="modal-body invite-modal-body">
    <p>
      Team members are emailed an invitation link when teams are created or you send reminders. If they did not receive an email, you can copy the
      individual team member invite link below and send it from your own email address.
    </p>
    <p>
      Note that the link will work only for members of the team who register with the same email address that was used to originally add them to the
      team.
    </p>
  </div>
  <div class="modal-footer invite-modal-footer">
    <div class="input-group mb-3">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="params.data.inviteLink"
        name="inviteLinkUrl"
        readonly="readonly"
        tabindex="-1"
        aria-describedby="button-copy-link"
      />
      <button (click)="copyLink()" class="btn-primary btn-primary-m" id="button-copy-link">Copy link</button>
    </div>
  </div>
</ng-template>
